import { Alert } from '@mui/material'

interface IProps {
    message: string
}

export default function DigitacaoErrorOverlay({ message }: IProps) {
    return (
        <div className="flex justify-center items-center h-full">
            <Alert
                severity="error"
                sx={{
                    width: 'fit-content',
                }}
            >
                {message ?? 'Erro ao carregar dados'}
            </Alert>
        </div>
    )
}
